import { LeihBarPermissions, PermissionEnum } from '@thro-types/access-handler';
import { User } from '@thro-types/users';

import { ACLHelper } from './ACLHelper';

export const isAreaAdmin = (user: User, permissions: PermissionEnum[]) => {
  const aclHelper = new ACLHelper(user);

  const isSelectionAdmin = aclHelper.isSelectionAdmin();
  const isJobmarketAdmin = aclHelper.isJobmarketAdmin();
  const isLeihBarAdmin = permissions?.includes(LeihBarPermissions.LEIHBAR_PRODUCT_EDIT_ANY);

  return isSelectionAdmin || isJobmarketAdmin || isLeihBarAdmin;
};

export const hasAtLeastOneActivityLogPermission = (permissions: PermissionEnum[]) => {
  return permissions?.some(permission => permission.startsWith('ACTIVITYLOG_'));
};
